import { startAndEndTime } from "./startAndEnd";

export const getdaysTimeStamp = (dayType:string) => {
  const today = new Date();
  let startDate: Date;
  let endDate: Date;

  switch (dayType) {
    case 'YESTERDAY':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - 1);
      endDate = new Date(startDate);
      break;

    case 'TODAY':
      startDate = new Date(today);
      endDate = new Date(today);
      break;

    case 'WEEK': {
      const dayOfWeek = today.getDay(); // Sunday = 0
      const diffToSunday = dayOfWeek;   // Week starts on Sunday
      startDate = new Date(today);
      startDate.setDate(today.getDate() - diffToSunday);
      endDate = new Date(today);
      break;
    }

    case 'MONTH':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today);
      break;

    default:
      throw new Error('Invalid date range type');
  }

  return startAndEndTime(startDate, endDate);
};